/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import BookingLoginAction from "store/bookingLogin/BookingLoginAction";
import update from "immutability-helper";
import {Reservation} from "types/entities/Reservation";
import {AccountDriver} from "types/entities/AccountDriver";

export interface BookingLoginReducerSetReservations {
    payload: Reservation[];
    type: typeof BookingLoginAction.SET_BOOKING_LOGIN_RESERVATIONS;
}

export interface BookingLoginReducerClearReservations {
    payload: Reservation[];
    type: typeof BookingLoginAction.CLEAR_BOOKING_LOGIN;
}

export interface BookingLoginReducerSetReservation {
    payload: Reservation;
    type: typeof BookingLoginAction.SET_BOOKING_LOGIN_RESERVATION;
}

export interface BookingLoginReducerSetUser {
    payload: AccountDriver;
    type: typeof BookingLoginAction.SET_BOOKING_LOGIN_USER;
}

type BookingLoginReducerAction = BookingLoginReducerSetReservations | BookingLoginReducerClearReservations | BookingLoginReducerSetReservation | BookingLoginReducerSetUser;

export interface BookingLoginReducerState {
    reservations: Reservation[];
    user: AccountDriver | null;
}

class BookingLoginReducer {
    initialState: BookingLoginReducerState = {
        reservations: [],
        user: null
    };

    reducer = (state: BookingLoginReducerState = this.initialState, action: BookingLoginReducerAction): BookingLoginReducerState => {
        switch (action.type) {
            case BookingLoginAction.SET_BOOKING_LOGIN_RESERVATIONS:
                return {
                    ...state,
                    reservations: action.payload,
                };

            case BookingLoginAction.SET_BOOKING_LOGIN_USER:
                return {
                    ...state,
                    user: action.payload,
                };

            case BookingLoginAction.CLEAR_BOOKING_LOGIN:
                return update(state, {
                    reservations: {
                        $set: action.payload,
                    },
                });

            case BookingLoginAction.SET_BOOKING_LOGIN_RESERVATION:
                const foundReservationIndex = state.reservations.findIndex(reservation => reservation.id === action.payload.id);

                if (foundReservationIndex === -1) {
                    return update(state, {
                        reservations: {
                            $push: [action.payload],
                        },
                    });
                }

                return update(state, {
                    reservations: {
                        [foundReservationIndex]: {
                            $set: action.payload,
                        },
                    },
                });
            default:
                return state;
        }
    };
}

export default BookingLoginReducer;
